import { addDoc, collection } from "firebase/firestore";
import GetAllParents from "../Users/GetAllParents";
import { db } from "../../firebase";

const StudentAbsentMailToParent = async (AttendanceObject) => {
  console.log("AttendanceObject", AttendanceObject);
  let resp = await GetAllParents();
  const Children = [];
  const ParentEmails = [];

  const EmailGeneration = async (parentsEmails, data) => {
    const mailCollection = collection(db, "mail");
    if (
      parentsEmails.length === 0 ||
      parentsEmails === null ||
      parentsEmails === undefined
    ) {
      return;
    }
    try {
      await addDoc(mailCollection, {
        to: parentsEmails,
        template: {
          name: "student-absent",
          subject: "Student Absent",
          data,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Get only the StudentRegistrationNo and doc id from  parents array of objects
  resp.forEach((parent) => {
    Children.push({
      parentData: parent,
      id: parent.id,
      childrenRegNo: parent.AdditionalDetails.StudentRegistrationNo,
    });
  });

  // Get the doc id's of all the parents when their children is absent
  AttendanceObject?.Students.forEach((std) => {
    Children.forEach(async (child) => {
      if (
        std.IsPresent === false &&
        child?.childrenRegNo.find((item) => item?.StudentId === std.id)
      ) {
        ParentEmails.push(child.parentData.Email);
      }
    });
  });

  EmailGeneration(ParentEmails, {
    AttendanceDate: AttendanceObject?.AttendanceDate?.toLocaleString(),
  });
};

export default StudentAbsentMailToParent;
